import { authGet, getData } from '../common'

export const getClausesByQuery = (q) => {
    return authGet({ url: `/clause?q=${JSON.stringify(q)}` }).then(getData)
}
